<template>
  <div>
    <div class="right-title">
      <span>顾问日志</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入关键字"
          v-model="search"
          clearable
          style="border-radius: 4px !important;">
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >

          <el-table-column
            prop="create_time"
            label="操作时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="type_name"
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: #00a2ea;cursor: pointer;" @click="showDetail(scope.row.content)">{{scope.row.type_name}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="organization_user_name"
            label="相关候选人"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="toHxr(scope.row.candidate_id)">{{scope.row.user_real_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="相关机构"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="toOrg(scope.row.org_id)">{{scope.row.organization_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="jobs_name"
            label="相关职位"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="toZw(scope.row.job_id)">{{scope.row.jobs_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="advname"
            label="相关顾问"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="toGw(scope.row.adv_id)">{{scope.row.advname}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="操作日志详情"
      append-to-body
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="40%">
      <div>{{rizhiContent}}</div>
    </el-dialog>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    data() {
      return {
        search: '',  // 搜索
        id: '',
        tableData: [],
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
        rizhiContent: '', //  日志详情
        dialogVisible: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      //顾问id
      this.id = this.$route.query.id
      this.$emit('setType', 0)
      //操作日志列表
      this.riZhiList()
    },
    methods: {
      //数据列表
      riZhiList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.listGwLog({
          user_id: this.id,
          searchName: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id
        })
          .then(res => {
            loading.close();
            this.page.pageNum = res.now_page
            this.page.pageTotal = res.total_number
            let List = res.data
            List.map(item => {
              item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)
            })
            this.tableData = List
          }).catch(res=>{
            loading.close();
          this.tableData = []
          this.page.pageTotal = res.total_number
        })
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },

      //  显示日志详情
      showDetail(str) {
        this.dialogVisible = true
        this.rizhiContent = str
      },
      //   去顾问
      toGw(id){
        this.$router.push('/home/gwAdmin/gwDetail/' + id)
      },
      //  去机构
      toOrg(id){
        this.$router.push('/home/jgAdmin/jgDetail/' + id)
      },
      //  去候选人
      toHxr(id) {
        this.$router.push('/home/hxrAdmin/hxrDetail/' + id)
      },
      //  去职位
      toZw(id) {
        this.$router.push('/home/zwAdmin/zwDetail/' + id)
      },


      keyWord() {     //  搜索
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/gwAdmin/gwRizhi',
          query: {
            id: this.$route.query.id,
            pageNum: this.page.pageNum,
            key: this.search
          }
        })
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.riZhiList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      /*left: 0;*/
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>